import { createSelector } from "reselect";
import { formatDate, parseDate } from "../utils/date";

const ileggelse = (state) => state.ileggelse;

export const getGridTableRowData = createSelector(ileggelse, (ileggelse) => {
  return [
    [
      {
        name: "Registrert i HGK",
        value: formatDate(parseDate(ileggelse.opprettetDato), "dateTime"),
        description: "",
      },
      {
        name: "Opprettet i Pocket Control",
        value: formatDate(parseDate(ileggelse.ileggelsesdatoFra), "dateTime"),
        description: "",
      },
    ],
  ];
});


